<template>
  <div class="gallery-card block-card card-border">
    <v-expansion-panel :value="panel" expand>
      <v-expansion-panel-content :lazy="lazyRendering">
        <template v-slot:header>
          <div class="block-card-title handle">
            <div class="title-icon">
              <span class="botter-gallery-icon white--text text-lg-2" />
            </div>

            <h4>
              Gallery
              <v-icon
                v-if="errorsCount && errorsCount.errorsCount"
                color="error"
                style="margin-left: 4px"
                >error</v-icon
              >
              <span class="text--error" v-if="!validData"
                >(Invalid Card Data)</span
              >
            </h4>
          </div>
        </template>
        <div v-if="validData" class="" style="">
            <div class="px-4">
              <label class="mt-3 d-inline-block">Body Text</label>
              <vTextareaAutocomplete
                v-model="data.text"
                :counter="1000"
                type="'textarea'"
                :validation-rules="
                  autocompleteGalleryHeaderValidationRules
                "
              />
            </div>
          <v-layout
            row
            wrap
            class="gallery-main-form-wrapper"
            style="width: 100%"
          >
            <v-flex xs6 class="mt-4">
              <v-layout row wrap style="padding-top: 0 !important">
                <v-flex style="margin-top: 0 !important" xs12>
                  <div
                    class="gallery-item delete-wrapper"
                    style="border: 0px solid !important"
                  >
                    <label class="d-block"
                      ><b>#{{ selectedIndex + 1 }}</b
                      >/{{ data.items.length }}</label
                    >
                    <label class="d-inline-block">Upload your image</label>
                    <image-input
                      ref="imageUploader"
                      :canRemove="true"
                      :url="
                        data.items[selectedIndex]
                          ? data.items[selectedIndex].url
                          : ''
                      "
                      drag-placeholder="Upload your image or gif"
                      @onUploadComplete="handleImageUpload"
                      @onFileRemove="handleImageRemove"
                      types="image/jpg, image/jpeg, image/png, image/gif"
                      :maxFiles="2"
                      :maxFilesize="5"
                    />
                    <form-validation
                      v-model="errorsCount"
                      :append="buttonsModel.errorsCount"
                    >
                      <label class="mt-3 d-inline-block"
                        ><span class="text-bold">Or</span> insert image or gif
                        or video link</label
                      >
                      <vTextareaAutocomplete
                        v-model="data.items[selectedIndex].url"
                        :validation-rules="
                          autocompleteGalleryUrlValidationRules
                        "
                        type="textfield"
                      />

                      <label class="mt-3 d-inline-block">Title</label>
                      <vTextareaAutocomplete
                        v-model="data.items[selectedIndex].header"
                        :counter="80"
                        :validation-rules="
                          autocompleteGalleryHeaderValidationRules
                        "
                        type="textfield"
                      />

                      <label class="mt-3 d-inline-block">Description</label>
                      <vTextareaAutocomplete
                        v-model="data.items[selectedIndex].description"
                        :counter="80"
                        :validation-rules="
                          autocompleteGalleryDescriptionValidationRules
                        "
                        type="textfield"
                      />
                    </form-validation>
                    <buttons-list
                      :buttons="data.items[selectedIndex].buttons"
                      :blocks-list="blocksList"
                      :limit="3"
                      v-model="buttonsModel"
                    />
                    <v-btn
                      class="delete-button"
                      fab
                      small
                      color=""
                      @click="deleteGalleryItem(selectedIndex)"
                      ><v-icon small color="#666">delete_outline</v-icon></v-btn
                    >
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex v-if="data.items.length" xs6 class="mt-3">
              <div class="d-flex">
                <span style="line-height: 4">Gallery Items</span>
                <v-spacer />
                <v-btn
                  :disabled="data.items.length >= maxItems"
                  flat
                  class="primary--text"
                  style="padding: 0px 0px !important; font-weight: bold"
                  @click="addGalleryItem"
                >
                  <v-icon>add_circle_outline</v-icon>
                  Add Gallery Item
                </v-btn>
              </div>
              <v-layout row wrap class="dimmed-card">
                <v-layout row wrap>
                  <v-layout row wrap style="width: 100%">
                    <v-flex xs11>
                      <v-card
                        :class="[
                          'preview-gallery-card pointer-cursor selected',
                        ]"
                        style="padding: 5px"
                      >
                        <v-img
                          :aspect-ratio="
                            data.items[selectedIndex] &&
                            data.items[selectedIndex].aspectRatio
                              ? data.items[selectedIndex].aspectRatio
                              : '1.5'
                          "
                          :src="
                            data.items[selectedIndex] &&
                            data.items[selectedIndex].url
                              ? data.items[selectedIndex].url
                              : ''
                          "
                          class="botter-card-image-title"
                          style=""
                        />
                        <v-card-title>
                          <div>
                            <span class="text-bold text-lg">{{
                              data.items[selectedIndex].header
                            }}</span
                            ><br />
                            <span>{{
                              data.items[selectedIndex].description
                            }}</span>
                          </div>
                        </v-card-title>
                        <v-flex xs12 style="">
                          <v-btn
                            v-for="(btn, b) in data.items[selectedIndex]
                              .buttons"
                            :key="b"
                            color="primary"
                            block
                            style="width: 100%"
                          >
                            {{ btn.title || "Unnamed Button" }}
                          </v-btn>
                        </v-flex>
                      </v-card>
                    </v-flex>
                    <v-flex xs1>
                      <div class="gallery-group-btn">
                        <v-btn
                          class="preview-delete-button"
                          fab
                          small
                          color=""
                          @click="deleteGalleryItem(index)"
                          ><v-icon small color="error"
                            >delete_outline</v-icon
                          ></v-btn
                        >
                      </div>
                    </v-flex>
                  </v-layout>
                  <div class="mat row grid-gallery-wrapper" style="width: 100%">
                    <div class="mat col s12 gallery-holder">
                      <draggable
                        v-model="data.items"
                        group="data.items"
                        style="width: 100%; z-index: 1"
                        handle=".drag-btn"
                        @start="drag = true"
                        @end="
                          drag = false;
                          handleDragEnd();
                        "
                      >
                        <div
                          v-for="(item, index) in data.items"
                          :key="index"
                          class="mat col s4 house-keeper"
                          style="height: 70px"
                          @click="selectedIndex = index"
                        >
                          <div
                            :style="{ background: `url(${item.url}) #FFFFFF` }"
                            :class="[
                              { 'selected-item': selectedIndex === index },
                              { 'top-left-br': index === 0 },
                              { 'top-right-br': index === 2 },
                              {
                                'bottom-left-br':
                                  index / 3 === getChunks() - 1 &&
                                  data.items.length % 3 !== 0,
                              },
                            ]"
                            class="mat row house-keeper gallery-grid-item"
                            style=""
                          >
                            <div class="mat col s6 house-keeper">
                              <div
                                :class="[
                                  'pointer-cursor',
                                  {
                                    'selected-index-num':
                                      selectedIndex === index,
                                  },
                                ]"
                                style="padding: 4px; font-weight: bold"
                              >
                                #{{ index + 1 }}
                              </div>
                            </div>
                            <div class="mat col s6 house-keeper right">
                              <div class="gallery-group-btn">
                                <v-btn
                                  class="side-btn"
                                  fab
                                  small
                                  color=""
                                  @click="deleteGalleryItem(index)"
                                  ><v-icon small color="error"
                                    >delete_outline</v-icon
                                  ></v-btn
                                >
                                <v-btn
                                  class="drag-btn side-btn"
                                  fab
                                  small
                                  color=""
                                  ><v-icon color="#666">height</v-icon></v-btn
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </draggable>
                      <div class="mat col s4 house-keeper">
                        <div
                          :class="[
                            'mat row house-keeper gallery-grid-item add-block-grid',
                            { 'top-left-br': !data.items.length },
                            { 'top-right-br': data.items.length === 2 },
                            { 'bottom-right-br': data.items.length % 3 === 2 },
                            { 'bottom-left-br': data.items.length % 3 === 0 },
                          ]"
                        >
                          <v-btn
                            :disabled="data.items.length >= maxItems"
                            @click="addGalleryItem"
                          >
                            <v-icon>add</v-icon>
                          </v-btn>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-layout>
              </v-layout>
            </v-flex>
          </v-layout>
          <!--  <v-layout
                        row
                        wrap>
                          <v-flex xs12 class="mt-5">
                            <div class="add-new-gallery-item" >
                                <v-btn
                                        large round flat block
                                        class="primary--text"
                                        :disabled = "data.items.length >= maxItems"
                                        @click="addGalleryItem"
                                >
                                    <v-icon>add_circle_outline</v-icon>
                                    Add Gallery Item
                                </v-btn>
                            </div>
                        </v-flex>
                    </v-layout> -->
        </div>
        <slot name="tail" />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<script>
import * as _ from "lodash";
import draggable from "vuedraggable";
import common from "../../../../utils/common";
import FormValidation from "../FormValidation";
import buttonsList from "./common-inner-blocks/button-list";
import imageInput from "./common-inner-blocks/image-uploader-dropzone";
export default {
  name: "CardGallery",
  components: {
    imageInput,
    buttonsList,
    draggable,
    FormValidation,
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
    index: {
      type: Number,
      default: () => {
        return 0;
      },
    },
    blocksList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    validData: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  data() {
    return {
      valid: true,
      maxItems: 10,
      selectedIndex: 0,
      errorsCount: { errorsCount: 0 },
      lazyRendering: true,
      buttonsModel: { errorsCount: 0 },
      panel: 1,
      common,
      autocompleteGalleryUrlValidationRules: [(v) => !!v || "URL is Required"],
      autocompleteGalleryHeaderValidationRules: [
        (v) => !!v || "Title is Required",
        (v) => (v && v.length < 80) || "Title should be less than 80 character",
      ],
      autocompleteGalleryDescriptionValidationRules: [
        (v) => !!v || "Description is Required",
        (v) =>
          (v && v.length < 80) ||
          "Description should be less than 80 character",
      ],
    };
  },
  computed: {},
  watch: {
    selectedIndex() {
      this.handleUploaderPlaceholder();
    },
    errorsCount(val) {
      this.$emit("input", { errorsCount: val.errorsCount });
      this.data.errorsCount = val.errorsCount;
    },
  },
  mounted() {
    if (this.data.errorsCount !== undefined) {
      this.errorsCount = this.data.errorsCount;
    } else {
      // disabling Lazy rendering so we can grip errors count
      this.lazyRendering = false;
      setTimeout(() => {
        // then we turn it on again to keep the performance up
        this.lazyRendering = true;
      }, 1000);
    }
  },
  methods: {
    addGalleryItem() {
      if (this.data.items.length >= this.maxItems) return;
      this.data.items.push({
        url: "",
        header: "",
        subtitle: "",
        imageUrl: "",
        description: "",
        buttons: [],
      });
      this.selectedIndex = this.data.items.length - 1;
    },
    handleImageUpload(event) {
      this.data.items[this.selectedIndex].url = event[0].url;
      this.data.items[this.selectedIndex].aspectRatio = event[0].aspectRatio;
    },
    handleImageRemove() {
      this.data.items[this.selectedIndex].url = "";
    },
    deleteGalleryItem(index) {
      this.data.items.splice(index, 1);
      // handle selected card
      this.selectedIndex = Math.max(0, index - 1);
    },
    handleDragEnd() {
      this.handleUploaderPlaceholder();
    },
    handleUploaderPlaceholder(selectedIndex = this.selectedIndex) {
      // handle showing uploader image on a new empty item
      if (
        !this.data.items[selectedIndex].url ||
        !this.data.items[selectedIndex].url.length
      ) {
        this.$refs.imageUploader.clear();
      }
    },
    getChunks(array = this.data.items) {
      return _.chunk(array, 3).length;
    },
  },
};
</script>

<style
  scoped
  lang="scss"
  src="../../../../assets/sass/commponents/gallery-card.scss"
></style>
